import DatePicker from "react-multi-date-picker";
import { Dropdown } from "primereact/dropdown";
import { useResourceRequest } from "../../Hooks/Features/HelpDesk/useResourceRequest";
import _ from "underscore";

const ResourceRequest = ({ dropDownOption, onClose }) => {

    const { popupFilters, setPopupFilters, handleCreateRequest, loader, handleTechnologySelected, experienceOpts, totalOpenUsers } = useResourceRequest({ dropDownOption, onClose });

    return (
        <div className="d-flex gap-2 justify-content-center align-items-center" style={{ height: "41vh" }}>
            <div className="w50 border-end pe-3 mt-1 d-flex flex-column gap-1">
                <div>
                    <div>Project Name</div>
                    <Dropdown placeholder="Project" className="input-dd" value={popupFilters?.project} onChange={(e) => setPopupFilters((prev) => ({ ...prev, project: e.target.value }))} showClear options={dropDownOption?.projects} optionLabel="project_name" filter filterInputAutoFocus />
                </div>
                <div>
                    <div>Technology Name</div>
                    <Dropdown placeholder="Technology" className="input-dd" value={popupFilters?.technology} onChange={(e) => setPopupFilters((prev) => ({ ...prev, technology: e.target.value }))} showClear options={dropDownOption?.technologies} optionLabel="technology_name" filter filterInputAutoFocus />
                </div>
                <div className="d-flex gap-3">
                    <div className="w50">
                        <div>Number of required resources</div>
                        <input className="w100 input-dd" type="number" placeholder="Number of resources" value={popupFilters?.resource_count} onChange={(e) => setPopupFilters((prev) => ({ ...prev, resource_count: e.target.value }))} min={1} />
                    </div>
                    <div className="w50">
                        <div>Work Experience of resource</div>
                        <Dropdown options={experienceOpts} value={popupFilters?.experience} onChange={(e) => setPopupFilters((prev) => ({ ...prev, experience: e.target.value }))} />
                    </div>
                </div>
                <div className="d-flex justify-content-between">
                    <div>
                        <div>Resource Period</div>
                        <div className="d-flex gap-2 align-items-center" style={{ height: "60%" }}>
                            <div className="d-flex justify-content-center align-items-center">
                                <input type="radio" className="c-pointer" value="permanent" onChange={(e) => setPopupFilters((prev) => ({ ...prev, type: e.target.value }))} checked={popupFilters?.type === "permanent"} name="resource_type" id="resource_perm" />
                                <label className="c-pointer" htmlFor="resource_perm">Permanent</label>
                            </div>
                            <div className="d-flex justify-content-center align-items-center">
                                <input type="radio" className="c-pointer" value="temp" onChange={(e) => setPopupFilters((prev) => ({ ...prev, type: e.target.value }))} checked={popupFilters?.type === "temp"} name="resource_type" id="resource_temp" />
                                <label className="c-pointer" htmlFor="resource_temp">Temporary</label>
                            </div>
                        </div>
                    </div>
                    <div style={{ visibility: popupFilters?.type === "temp" ? "visible" : "hidden" }}>
                        <div>Select Date: </div>
                        <DatePicker placeholder="Select Date Range" value={popupFilters?.hoveredRange} onChange={(e) => setPopupFilters((prev) => ({ ...prev, hoveredRange: e }))} range rangeHover minDate={new Date()} />
                    </div>
                </div>
                <div className="text-right mt-3">
                    <button className="button btn-default" onClick={() => onClose()}>Cancel</button>
                    {loader ?
                        <button className="button btn-primary w15">
                            <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                <span className="sr-only"></span>
                            </div>
                        </button> :
                        <button className="button btn-primary w15" onClick={() => handleCreateRequest()}>Submit</button>
                    }
                </div>
            </div>
            <div className="w50 px-3" style={{ height: "100%", overflowY: "auto" }}>
                <div className="text-right mb-2">Total Open Opportunity Employees: <span className="fw-bold">{totalOpenUsers}</span></div>
                <div className="d-flex flex-wrap gap-3 ">
                    {_.sortBy(dropDownOption?.technologies, "user_count")?.reverse()?.map((item, index) => (
                        <div className="d-flex flex-column w30 shadow rounded p-2 bg-white c-pointer open-oppo-card" key={index} onClick={() => handleTechnologySelected(item?.technology_name)}>
                            <span className="fs-5 fw-bold">{item?.user_count}</span>
                            <span className="text-truncate" title={item?.technology_name}>{item?.technology_name}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default ResourceRequest;